import { useContext } from 'react';
import ScriptContext from './ScriptContext';

function Image(props) {
  const { projects } = useContext(ScriptContext);

  // If no project yet, render nothing (shouldn’t happen since Project registers synchronously)
  if (!projects || projects.length === 0) return null;

  // The current <Image> instances belong to the most recently registered <Project>
  const project = projects[projects.length - 1];
  if (!project || !project.config || !Array.isArray(project.config.items)) return null;

  const fqsrc =
    "/images/projects/" +
    project.year +
    "/" +
    project.name.replace(/\s/g, "%20") +
    "/" +
    props.src;

  // 🔸 Register this image synchronously (avoid duplicates on re-renders)
  const already = project.config.items.some(function (it) { return it.src === fqsrc; });
  if (!already) {
    project.config.items.push({ src: fqsrc, title: props.title });
    // console.log("🖼️ Registered image:", project.name, fqsrc);
  }

  // This component only contributes to popup config; no DOM needed
  return null;
}

export default Image;
